import React from "react";
import { Lightbulb, Package, PackageOpen } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import { formatUsedPrice } from "@/lib/price";

const BundleAnalysis = ({ value }) => {
  const { t } = useLang();
  const whole = Number(value) || 0;
  const partsLow = whole * 1.15;
  const partsHigh = whole * 1.25;

  return (
    <div data-testid="bundle-analysis" className="lg:col-span-12 border border-black bg-[#FFCC00]/10 p-6 sm:p-8">
      <span className="overline">{t.results.bundle_title}</span>
      <p className="text-sm text-[#4A4A4A] mt-2">{t.results.bundle_hint}</p>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div data-testid="bundle-whole" className="border border-black bg-white p-5">
          <div className="flex items-center gap-2 text-[#4A4A4A]">
            <Package size={16} />
            <span className="overline text-[10px]">{t.results.bundle_whole}</span>
          </div>
          <div className="font-display font-black text-3xl mt-2 text-[#0A0A0A]">{formatUsedPrice(whole)}</div>
        </div>

        <div data-testid="bundle-parts" className="border border-black bg-[#0A0A0A] text-white p-5">
          <div className="flex items-center gap-2 text-[#FFCC00]">
            <PackageOpen size={16} />
            <span className="overline text-[10px]">{t.results.bundle_parts}</span>
          </div>
          <div className="font-display font-black text-3xl mt-2">
            {formatUsedPrice(partsLow)} – {formatUsedPrice(partsHigh)}
          </div>
          <div className="font-mono text-[10px] tracking-wide uppercase mt-1 text-white/60">{t.results.bundle_parts_note}</div>
        </div>
      </div>

      <div data-testid="bundle-tip" className="mt-4 flex items-start gap-2 bg-white border border-black px-4 py-3">
        <Lightbulb size={16} className="text-[#002FA7] flex-shrink-0 mt-0.5" />
        <span className="text-sm font-medium">{t.results.bundle_tip}</span>
      </div>
    </div>
  );
};

export default BundleAnalysis;
